/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
  GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams,
  GetApiV1IndividualpaymentSharedCourseRegistrations401,
  GetApiV1IndividualpaymentSharedCourseRegistrations500,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedCourseRegistrations.ts";

function getGetApiV1IndividualpaymentSharedCourseRegistrationsUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/shared/course-registrations` as const,
  };
  return res;
}

/**
 * @description Retorna as matrículas da pessoa com rótulo "[Turma]Curso". O parâmetro 'companyId' usa igualdade exata (null retorna apenas matrículas sem empresa), sobreposto pela empresa do usuário autenticado. Migrado do legado CourseAsync/GetCourseRegistrationsByPerson. **(Requer Authorization para autenticação)**
 * @summary Dropdown de matrículas de uma pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/shared/course-registrations}
 */
export async function getApiV1IndividualpaymentSharedCourseRegistrations(
  params?: GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedCourseRegistrations401
      | GetApiV1IndividualpaymentSharedCourseRegistrations500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentSharedCourseRegistrationsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
